<app-install-pwa-prompt *ngIf="pwaInstallService.bannerVisible$ | async" />
<app-chat-client-panel *ngIf="chatClientService.isEnabled" />
<router-outlet *ngIf="!isSiteUnderMaintenance"></router-outlet>
<div *ngIf="isSiteUnderMaintenance">
  <temporarily-unavailable></temporarily-unavailable>
</div>
